// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkusSlider_skus-slider__z4ApW {
  --slider-width: 0;
}

.SkusSlider_skus-slider__title__oBX7W {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 700;
  margin-bottom: 4rem;
}

.SkusSlider_skus-slider__loading__mOdCq {
  margin-inline: auto;
  width: 12rem;
  height: 12rem;
}

.SkusSlider_skus-slider__swiper-container__TTrgr {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.SkusSlider_skus-slider__swiper__ZAo4d {
  margin-bottom: 8rem;
  width: var(--slider-width);
}

.SkusSlider_skus-slider__swiper-pagination__WGGIR {
  align-self: center;
}

.SkusSlider_skus-slider__swiper-slide__7Ko0H {
  height: auto;
}

.SkusSlider_skus-slider__sku-card__zGSfD {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/SkusSlider/SkusSlider.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".skus-slider {\n  --slider-width: 0;\n}\n\n.skus-slider__title {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 700;\n  margin-bottom: 4rem;\n}\n\n.skus-slider__loading {\n  margin-inline: auto;\n  width: 12rem;\n  height: 12rem;\n}\n\n.skus-slider__swiper-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.skus-slider__swiper {\n  margin-bottom: 8rem;\n  width: var(--slider-width);\n}\n\n.skus-slider__swiper-pagination {\n  align-self: center;\n}\n\n.skus-slider__swiper-slide {\n  height: auto;\n}\n\n.skus-slider__sku-card {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skus-slider": `SkusSlider_skus-slider__z4ApW`,
	"skus-slider__title": `SkusSlider_skus-slider__title__oBX7W`,
	"skus-slider__loading": `SkusSlider_skus-slider__loading__mOdCq`,
	"skus-slider__swiper-container": `SkusSlider_skus-slider__swiper-container__TTrgr`,
	"skus-slider__swiper": `SkusSlider_skus-slider__swiper__ZAo4d`,
	"skus-slider__swiper-pagination": `SkusSlider_skus-slider__swiper-pagination__WGGIR`,
	"skus-slider__swiper-slide": `SkusSlider_skus-slider__swiper-slide__7Ko0H`,
	"skus-slider__sku-card": `SkusSlider_skus-slider__sku-card__zGSfD`
};
export default ___CSS_LOADER_EXPORT___;
